import { NgForOf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Question } from '@models/dynamic-forms/question';

@Component({
  selector: 'app-select-input',
  templateUrl: './select-input.component.html',
  imports: [ReactiveFormsModule, NgForOf],
})
export class SelectInputComponent {
  @Input() public form: FormGroup;
  @Input() public question: Question;
}
